import GallerySimple from "../blocks/gallery-simple";
import Gallery from "../blocks/gallery";
import GalleryVideo from "../blocks/gallery-video";

const Contacts = {
  init() {

    Contacts.teamGrid();

    new GallerySimple(".gallery-simple");
    new Gallery(".gallery");
    new GalleryVideo(".gallery-video");
  },

  teamGrid() {
    const teamGrid = document.querySelector(".amro-team__grid");
    if (!teamGrid) return;

    const persons = teamGrid.querySelectorAll(".person");
    const joinCard = teamGrid.querySelector(".joinus-card");
    const remainder = persons.length % 3;

    if (!joinCard) return;

    if (remainder !== 0) {
      joinCard.classList.add("visible");
    }

    if (remainder === 1) {
      joinCard.classList.add("large");
    }
  },

 
};

export default Contacts;
